import React from 'react';
import './CompraDetalhes.css';

const CompraDetalhes = ({ compra, onFechar }) => {
  if (!compra) return null;

  const formatarData = (dataString) => {
    if (!dataString) return '-';
    const data = new Date(dataString);
    return data.toLocaleDateString('pt-BR');
  };

  const getStatusBadge = (status) => {
    const classes = {
      'ABERTA': 'status-aberta',
      'APROVADA': 'status-aprovada',
      'RECEBIDA': 'status-recebida',
      'CANCELADA': 'status-cancelada'
    };

    return (
      <span className={`status-badge ${classes[status] || ''}`}>
        {status}
      </span>
    );
  };

  return (
    <div className="modal-overlay" onClick={onFechar}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Detalhes da Compra #{compra.id}</h2>
          <button className="modal-close" onClick={onFechar}>×</button>
        </div>

        <div className="modal-body">
          {/* Seção de Informações Gerais */}
          <div className="detalhes-section">
            <h3>Informações Gerais</h3>
            <div className="detalhes-grid">
              <div className="detalhes-item">
                <label>Status</label>
                <div>{getStatusBadge(compra.status)}</div>
              </div>
              <div className="detalhes-item">
                <label>Data Solicitação</label>
                <p>{formatarData(compra.dataSolicitacao)}</p>
              </div>
              <div className="detalhes-item">
                <label>Data Aprovação</label>
                <p>{formatarData(compra.dataAprovacao) || '-'}</p>
              </div>
              <div className="detalhes-item">
                <label>Data Recebimento</label>
                <p>{formatarData(compra.dataRecebimento) || '-'}</p>
              </div>
              <div className="detalhes-item">
                <label>Valor Total</label>
                <p className="valor-destaque">R$ {compra.valorTotal?.toFixed(2) || '0.00'}</p>
              </div>
              <div className="detalhes-item">
                <label>Gerado Automaticamente</label>
                <p>{compra.geradoAutomaticamente ? 'Sim' : 'Não'}</p>
              </div>
            </div>
          </div>

          {/* Seção de Fornecedor */}
          <div className="detalhes-section">
            <h3>Informações do Fornecedor</h3>
            <div className="fornecedor-info">
              <div className="fornecedor-grid">
                <div className="detalhes-item">
                  <label>Nome da Empresa</label>
                  <p className="fornecedor-nome">{compra.fornecedorNome || 'Não informado'}</p>
                </div>
                <div className="detalhes-item">
                  <label>CNPJ</label>
                  <p>{compra.fornecedorCnpj || 'Não informado'}</p>
                </div>
                <div className="detalhes-item">
                  <label>Telefone</label>
                  <p>{compra.fornecedorTelefone || 'Não informado'}</p>
                </div>
                <div className="detalhes-item">
                  <label>Email</label>
                  <p className="email-link">
                    {compra.fornecedorEmail ? (
                      <a href={`mailto:${compra.fornecedorEmail}`}>{compra.fornecedorEmail}</a>
                    ) : (
                      'Não informado'
                    )}
                  </p>
                </div>
                <div className="detalhes-item detalhes-item-full">
                  <label>Endereço</label>
                  <p>{compra.fornecedorEndereco || 'Não informado'}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Seção de Itens/Materiais */}
          <div className="detalhes-section">
            <h3>Itens da Compra</h3>
            {compra.itens && compra.itens.length > 0 ? (
              <div className="itens-detalhes-tabela">
                <table>
                  <thead>
                    <tr>
                      <th>Material</th>
                      <th>Cor</th>
                      <th>Unidade</th>
                      <th>Quantidade</th>
                      <th>Valor Unitário</th>
                      <th>Subtotal</th>
                    </tr>
                  </thead>
                  <tbody>
                    {compra.itens.map((item, index) => (
                      <tr key={index}>
                        <td>{item.materiaPrimaNome}</td>
                        <td>{item.materiaPrimaCor || '-'}</td>
                        <td>{item.unidade || '-'}</td>
                        <td className="quantidade-destaque">{item.quantidade}</td>
                        <td>R$ {item.valorUnitario?.toFixed(2)}</td>
                        <td className="subtotal-destaque">R$ {item.subtotal?.toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="5" className="total-label">Total da Compra:</td>
                      <td className="total-valor">R$ {compra.valorTotal?.toFixed(2) || '0.00'}</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            ) : (
              <p className="sem-itens">Nenhum item cadastrado nesta compra</p>
            )}
          </div>

          {/* Seção de Observações */}
          {compra.observacao && (
            <div className="detalhes-section">
              <h3>Observações</h3>
              <div className="observacao-box">
                <p>{compra.observacao}</p>
              </div>
            </div>
          )}

          {/* Seção de Responsável */}
          {compra.responsavelNome && (
            <div className="detalhes-section">
              <h3>Responsável</h3>
              <div className="detalhes-item">
                <label>Nome</label>
                <p>{compra.responsavelNome}</p>
              </div>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn-fechar-modal" onClick={onFechar}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompraDetalhes;
